import { ga, outbrain, strossle, taboola } from 'js/analytics/adapters'

export const trackAppStoreButtonClick = ({ type }) => {
  ga.track('app_store_buttons_click', {
    type,
  })

  strossle.track('conversion')
  outbrain.track('Add to cart')
  taboola.track('add_to_cart')
}
